'use client'

import React from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Inter } from 'next/font/google'
import { CustomSvgIcon } from '@/styles/icon'

const inter = Inter({ subsets: ['latin'] })

const Toast: React.FC = () => {
  return (
    <ToastContainer
      position='top-right'
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      className={'text-base'}
    />
  )
}

export const showToast = (
  message: string,
  type: 'info' | 'success' | 'warning' | 'error' | 'no-update',
  autoClose?: number,
) => {
  switch (type) {
    case 'info':
      toast.info(message)
      break
    case 'success':
      toast.success(message, {
        style: {
          backgroundColor: '#E2EEE8',
          border: '1px solid #BADBCC',
          color: '#12574F',
          fontFamily: inter.style.fontFamily,
          fontStyle: 'normal',
          lineHeight: '24px',
        },
        hideProgressBar: true,
        icon: <CustomSvgIcon name='toastSuccess' />,
        closeButton: false,
        autoClose: autoClose ? autoClose : 5000,
      })
      break
    case 'warning':
      toast.warning(message, {
        style: {
          backgroundColor: '#FFF3CD',
          border: '1px solid #FFECB5',
          color: '#664D03',
          fontFamily: inter.style.fontFamily,
          fontStyle: 'normal',
          lineHeight: '24px',
        },
        hideProgressBar: true,
        icon: <CustomSvgIcon name='infoCircleFill' />,
        closeButton: false,
      })
      break
    case 'error':
      toast.error(message, {
        style: {
          backgroundColor: '#F8D7DA',
          border: '1px solid #F5C2C7',
          color: '#842029',
          fontFamily: inter.style.fontFamily,
          fontStyle: 'normal',
          lineHeight: '24px',
        },
        hideProgressBar: true,
        icon: <CustomSvgIcon name='toastError' />,
        closeButton: false,
        autoClose: autoClose ? autoClose : 5000,
      })
      break
    case 'no-update':
      toast.success(message, {
        style: {
          backgroundColor: '#CFF4FC',
          border: '1px solid #B6EFFB',
          color: '#055160',
          fontFamily: inter.style.fontFamily,
          fontStyle: 'normal',
          lineHeight: '24px',
        },
        hideProgressBar: true,
        icon: <CustomSvgIcon name='noUpdate' />,
        closeButton: false,
      })
      break
    default:
      toast(message)
  }
}

export default Toast
